import React, { useCallback, useEffect, useRef, useState } from 'react';
import classes from './Documents.module.scss'
import get from '../../../services/axios/get';
import DragAndDropUpload from '../../UI/DragAndDrop/DragAndDropUpload';
import { customAlert } from '../../../store/actions/alert';
import { useAppDispatch } from '../../../store/hooks';
import post from '../../../services/axios/post';
import Loader from '../../UI/Loader/Loader';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Button, Input } from 'reactstrap';
import { CgMenu } from 'react-icons/cg';
import Alert from '../../UI/Alert/Alert';
import del from '../../../services/axios/delete';
import { FaUpload, FaDownload, FaEye, FaWhatsapp, FaWeightHanging } from 'react-icons/fa';
import Load from '../../../models/load';
import LoadPdf, { MyDocument } from '../LoadPdf/LoadPdf';
import { PDFDownloadLink, pdf } from '@react-pdf/renderer';
import ChargesPdf, { ChargesDocument } from '../ChargesPdf/ChargesPdf';
import Modal from '../../../containers/Modal/Modal';
import axios from 'axios';
import patch from '../../../services/axios/patch';

interface DocumentsProps {
  load: Load
  userType: string
  ownerViewRestricted?: boolean
  onRefreshLoads?: () => void
  onClose?: () => void
}
export interface Document {
  id: string;
  loadId: string;
  createdAt: string;
  updatedAt: string;
  documentName: string;
  documentType: string;
  key: string;
  signedUrl: string;
  greyedOut?: boolean;
}

const Documents: React.FC<DocumentsProps> = (props: DocumentsProps) => {
  const isMounted = useRef(true);
  const [deletionId, setDeletionId]: [string | null, any] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSendLoading, setIsSendLoading] = useState(false);
  const [isSendingCTO, setIsSendingCTO] = useState(false);
  const [isVgmUpdating, setIsVgmUpdating] = useState(false);
  const [documents, setDocuments]: [
    Document[],
    (documents: any) => any
  ] = useState([]);
  const dispatch = useAppDispatch();
  const [openDocumentMenu, setOpenDocumentMenu]: [string | null, any] = useState(null);
  const [viewingDocument, setViewingDocument] = useState<Document | null>(null);
  const [vgmLoadpoint1, setVgmLoadpoint1] = useState<string>('');
  const [vgmLoadpoint2, setVgmLoadpoint2] = useState<string>('');
  const [containerTare, setContainerTare] = useState<string>('');
  const [totalVgm, setTotalVgm] = useState<number>(0);
  const [temptaleNumber, setTemptaleNumber] = useState<string>('');
  const [isTemptaleUpdating, setIsTemptaleUpdating] = useState(false);
  const [vgmLoadpoint1Error, setVgmLoadpoint1Error] = useState<string>('');
  const [vgmLoadpoint2Error, setVgmLoadpoint2Error] = useState<string>('');
  const [containerTareError, setContainerTareError] = useState<string>('');
  const [totalVgmError, setTotalVgmError] = useState<string>('');
  const fixedDocuments = [
    'Q67.clientRef.pdf',
    'Navis.clientRef.pdf',
    'Driver CTO.clientRef.pdf',
    'Container Photo.clientRef.jpeg',
    'Depot Stamp.clientRef.jpeg',
    'Seal Photo.clientRef.jpeg',
    'Temptale 1 Photo.clientRef.jpeg',
    'Temptale 2 Photo.clientRef.jpeg',
    'VGM 1 Photo.clientRef.jpeg',
    'VGM 2 Photo.clientRef.jpeg',
    'Port Slip Photo.clientRef.jpeg'
  ];
  const fileInputRef: any = useRef(null);
  const [documentToUpload, setDocumentToUpload]: [Document | null, any] = useState(null)
  const [showPdf, setShowPdf]: [string | null, any] = useState(null)
  const [extraDocumentName, setExtraDocumentName] = useState<string>('');
  const [isUploadingExtra, setIsUploadingExtra] = useState<boolean>(false);

  const forceDownload = async (url: string, filename: string) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Download failed:', error);
      window.open(url, '_blank');
    }
  };

  const isPDFDocument = (documentName: string) => {
    return documentName.toLowerCase().endsWith('.pdf');
  };

  const isVGMDocument = (docName: string) => {
    return docName.startsWith('VGM ');
  };

  const isTemptaleDocument = (docName: string) => {
    return docName.startsWith('Temptale ');
  };

  const isPackHouseUploadableDocument = (docName: string) => {
    return isVGMDocument(docName) || isTemptaleDocument(docName);
  };

  const validateVgmWeight = (value: string, setError: (error: string) => void) => {
    const numValue = parseFloat(value);
    if (value && !isNaN(numValue) && numValue > 34000) {
      setError('Weight cannot exceed 34 tons');
      return false;
    } else {
      setError('');
      return true;
    }
  };

  const handleVgmLoadpoint1Change = (value: string) => {
    setVgmLoadpoint1(value);
    validateVgmWeight(value, setVgmLoadpoint1Error);
  };

  const handleVgmLoadpoint2Change = (value: string) => {
    setVgmLoadpoint2(value);
    validateVgmWeight(value, setVgmLoadpoint2Error);
  };

  const handleContainerTareChange = (value: string) => {
    setContainerTare(value);
    validateVgmWeight(value, setContainerTareError);
  };

  const deleteDocument = async (documentId: string) => {
    del(
      `/document/${documentId}`,
      {},
      () => {
        getDocuments();
      },
      (error: any) => {
        dispatch(customAlert(true, error))
      }
    )
  }

  const onFileUpload = async (file: File, documentName?: string) => {
    setIsLoading(true);

    get(
      '/document/upload',
      {
        documentName: documentName ?? file.name,
        loadId: props.load.id
      },
      async (response) => {
        const uploadResponse = await fetch(response.data.uploadUrl, {
          method: 'PUT',
          body: file,
          headers: {
            'Content-Type': file.type
          }
        });

        if (uploadResponse.ok) {
          post(
            '/document',
            {
              documentName: documentName ?? file.name,
              loadId: props.load.id
            },
            (response) => {
              if (fileInputRef.current != null) {
                fileInputRef.current.value = '';
              }

              getDocuments();
            },
            (error: any) => {
              dispatch(customAlert(true, error))
            }
          )
        } else {
          dispatch(customAlert(true, 'Upload failed'))
        }
      },
      () => { }
    )
  };

  const getDocuments = useCallback(
    () => {
      setIsLoading(true)
      get(
        '/document',
        { loadId: props.load.id },
        (res) => {
          if (isMounted) {
            setDocuments(res.data);
            setIsLoading(false)
          }
        },
        () => { }
      );
    },
    [setDocuments, setIsLoading, props.load.id]
  );

  const renderDocuments = () => {
    const filteredFixedDocuments: Document[] = fixedDocuments.filter(fixedDocName =>
      !documents.some(doc => {
        const actualNameParts = doc.documentName.split('.');
        const fixedNameParts = fixedDocName.split('.');

        return actualNameParts[0] === fixedNameParts[0];
      })
    ).map(name => ({
      documentName: name.split('.')[0],
      greyedOut: true,
      id: '',
      loadId: '',
      signedUrl: '',
      documentType: '',
      createdAt: '',
      updatedAt: '',
      key: name
    }));

    let allDocuments = [...filteredFixedDocuments, ...documents];

    if (props.ownerViewRestricted) {
      allDocuments = allDocuments.filter(doc => {
        const docName = doc.documentName.split('.')[0];
        return docName === 'CTO' || docName === 'Driver CTO';
      });
    }

    return allDocuments.map((document, index) => {
      const documentClasses = [classes.doc, 'py-1', document.greyedOut ? classes['greyed-out'] : ''].join(' ');

      if (document.documentName.split('.')[0] === 'Booking Photo') {
        return null
      }

      const content = (
        <div className={documentClasses} key={index}>
          <div style={{ paddingRight: '1rem' }}>{document.documentName.split('.')[0]}</div>

          {!document.greyedOut ? (
            <div className={classes.actionsContainer}>
              {(props.userType === 'packHouse' || props.userType === 'plugDepot' || props.userType === 'admin' || props.userType === 'exporter' || props.userType === 'client') && (
                <>
                  {isVGMDocument(document.documentName.split('.')[0]) && (props.userType === 'packHouse' || props.userType === 'plugDepot' || props.userType === 'admin') ? (
                    <FaWeightHanging
                      className={classes.viewIcon}
                      onClick={() => setViewingDocument(document)}
                      style={{ cursor: 'pointer', marginRight: '0.5rem', color: 'var(--theme-green)' }}
                    />
                  ) : isTemptaleDocument(document.documentName.split('.')[0]) && (props.userType === 'packHouse' || props.userType === 'plugDepot') ? (
                    <FaEye
                      className={classes.viewIcon}
                      onClick={() => setViewingDocument(document)}
                      style={{ cursor: 'pointer', marginRight: '0.5rem', color: 'var(--theme-blue)' }}
                    />
                  ) : (
                    <FaEye
                      className={classes.viewIcon}
                      onClick={() => setViewingDocument(document)}
                      style={{ cursor: 'pointer', marginRight: '0.5rem', color: 'var(--theme-blue)' }}
                    />
                  )}
                </>
              )}

              <Dropdown
                isOpen={openDocumentMenu === document.id}
                toggle={() => setOpenDocumentMenu(openDocumentMenu === null ? document.id : null)}
                direction={'down'}
                className={classes['dropdown']}
              >
                <DropdownToggle><CgMenu size={'16'} /></DropdownToggle>
                <DropdownMenu>
                  {document.signedUrl && <div className={classes.download} onClick={() => forceDownload(document.signedUrl, document.documentName)}><DropdownItem>
                    Download
                  </DropdownItem></div>}

                  {props.userType === 'admin' && (
                    <>
                      <DropdownItem onClick={() => setDeletionId(document.id)}>Delete</DropdownItem>
                    </>
                  )}
                </DropdownMenu>
              </Dropdown>
            </div>
          ) : (
            props.userType !== 'client' && props.userType !== 'exporter' && !props.ownerViewRestricted ? (
              <div className={classes.upload} onClick={() => {
                if ((props.userType === 'packHouse' || props.userType === 'plugDepot') && !isPackHouseUploadableDocument(document.documentName.split('.')[0])) {
                  return;
                }

                if (fileInputRef.current?.click != null) {
                  setDocumentToUpload(document);
                  fileInputRef.current.click()
                }
              }}>
                {(props.userType === 'packHouse' || props.userType === 'plugDepot' || props.userType === 'admin' || props.userType === 'exporter' || props.userType === 'client') && (
                  <>
                    {isVGMDocument(document.documentName.split('.')[0]) ? (
                      <FaWeightHanging
                        className={classes.viewIcon}
                        onClick={(e) => {
                          e.stopPropagation();
                          setViewingDocument({ ...document, signedUrl: '' });
                        }}
                        style={{ cursor: 'pointer', marginLeft: '0.5rem', color: 'var(--theme-green)' }}
                      />
                    ) : isTemptaleDocument(document.documentName.split('.')[0]) ? (
                      <FaEye
                        className={classes.viewIcon}
                        onClick={(e) => {
                          e.stopPropagation();
                          setViewingDocument({ ...document, signedUrl: '' });
                        }}
                        style={{ cursor: 'pointer', marginLeft: '0.5rem', color: 'var(--theme-blue)' }}
                      />
                    ) : (
                      <FaEye
                        className={classes.viewIcon}
                        onClick={(e) => {
                          e.stopPropagation();
                          setViewingDocument({ ...document, signedUrl: '' });
                        }}
                        style={{ cursor: 'pointer', marginLeft: '0.5rem', color: 'var(--theme-blue)' }}
                      />
                    )}
                  </>
                )}
                {(() => {
                  if (props.userType === 'admin') return <FaUpload />;
                  if (props.userType === 'packHouse' || props.userType === 'plugDepot') {
                    return isPackHouseUploadableDocument(document.documentName.split('.')[0]) ? <FaUpload /> : null;
                  }
                  if (props.userType !== 'packHouse' && props.userType !== 'plugDepot') return <FaUpload />;
                  return null;
                })()}
              </div>
            ) : null
          )}
        </div>
      );

      if (props.ownerViewRestricted) {
        return content;
      }

      if (props.userType === 'client' || props.userType === 'exporter') {
        return content;
      }

      if (props.userType === 'admin') {
        return (
          <DragAndDropUpload onFileUpload={(file) => {
            onClickedFileUpload(file, document.key)
          }}>
            {content}
          </DragAndDropUpload>
        );
      }

      if (props.userType === 'packHouse' || props.userType === 'plugDepot') {
        if (isPackHouseUploadableDocument(document.key.split('.')[0])) {
          return (
            <DragAndDropUpload onFileUpload={(file) => {
              onClickedFileUpload(file, document.key)
            }}>
              {content}
            </DragAndDropUpload>
          );
        }
        return content;
      }

      return (
        <DragAndDropUpload onFileUpload={(file) => {
          onClickedFileUpload(file, document.key)
        }}>
          {content}
        </DragAndDropUpload>
      );
    });
  };

  const onClickedFileUpload = (file: File, documentName?: string): void => {
    // @ts-expect-error
    const nameParts = documentName != null ? documentName.split('.') : documentToUpload.key.split('.');
    const secondPart = props.load[nameParts[1] as keyof Load] != null && props.load[nameParts[1] as keyof Load] !== '' ? `.${props.load[nameParts[1] as keyof Load]}` : '';
    const fileNameParts = file.name.split('.')

    onFileUpload(file, `${nameParts[0]}${secondPart}.${fileNameParts[fileNameParts.length - 1]}`);
  }

  const onExtraFileUpload = (file: File) => {
    setIsUploadingExtra(true);
    const fileNameToUse = extraDocumentName.trim() ?
      `${extraDocumentName}.${file.name.split('.').pop()}` :
      file.name;

    const baseName = extraDocumentName.trim() ? extraDocumentName : file.name.split('.')[0];

    const isFixedDoc = fixedDocuments.some(doc => {
      const fixedDocBaseName = doc.split('.')[0];
      return baseName === fixedDocBaseName || baseName.startsWith(fixedDocBaseName + ' ');
    });

    const isReservedDoc = isFixedDoc || baseName === 'CTO' || baseName === 'Additional Charges';

    if (isReservedDoc) {
      dispatch(customAlert(true, 'Cannot upload standard documents here. Please use the designated upload sections for standard documents.'));
      setIsUploadingExtra(false);
      return;
    }

    onFileUpload(file, fileNameToUse);
    setExtraDocumentName('');
    setIsUploadingExtra(false);
  }

  const sendCTOToDriver = async () => {
    setIsSendLoading(true)

    const doc = <MyDocument load={props.load} />;
    const blob = await pdf(doc).toBlob();

    get(
      '/send',
      { documentName: `CTO.${props.load.clientRef}.pdf` },
      async (res) => {
        if (isMounted) {
          setIsSendLoading(false)
        }

        const uploadUrl = res.data.uploadUrl
        const key = res.data.key

        try {
          await axios.put(uploadUrl, blob, {
            headers: {
              'Content-Type': 'application/pdf',
            },
          });

          post(
            '/send',
            {
              key: key,
              loadId: props.load.id
            },
            (response) => {
              dispatch(customAlert(true, 'CTO sent successfully'))
              setIsSendLoading(false);
            },
            (error: any) => {
              dispatch(customAlert(true, error))
              setIsSendLoading(false);
            }
          )
        } catch (error) {
          dispatch(customAlert(true, 'CTO Upload failed'))
          setIsSendLoading(false);
        }
      },
      () => {
        dispatch(customAlert(true, 'Failed to get upload url'))
        setIsSendLoading(false);
      }
    );
  };

  const updateVGMData = () => {
    const hasErrors = vgmLoadpoint1Error || vgmLoadpoint2Error || containerTareError || totalVgmError;
    if (hasErrors) {
      dispatch(customAlert(true, "A Load cannot exceed 34 tons"));
      return;
    }

    setIsVgmUpdating(true);
    const patchData = {
      vgmLoadpoint1,
      vgmLoadpoint2,
      containerTare
    };

    patch(
      `/load/${props.load.id}`,
      patchData,
      () => {
        if (isMounted.current) {
          setIsVgmUpdating(false);
          dispatch(customAlert(false, "VGM data updated successfully"));
          setViewingDocument(null);
          if (props.onRefreshLoads) {
            props.onRefreshLoads();
          }
          if (props.onClose) {
            props.onClose();
          }
        }
      },
      (err) => {
        if (isMounted.current) {
          setIsVgmUpdating(false);
          dispatch(customAlert(true, err || "Failed to update VGM data"));
        }
      }
    );
  };

  const updateTemptaleNumber = () => {
    setIsTemptaleUpdating(true);

    patch(
      `/load/${props.load.id}`,
      { temptaleNumber },
      () => {
        if (isMounted.current) {
          setIsTemptaleUpdating(false);
          dispatch(customAlert(false, "Temptale number updated successfully"));
          setViewingDocument(null);
          if (props.onRefreshLoads) {
            props.onRefreshLoads();
          }
          if (props.onClose) {
            props.onClose();
          }
        }
      },
      (err) => {
        if (isMounted.current) {
          setIsTemptaleUpdating(false);
          dispatch(customAlert(true, err || "Failed to update Temptale number"));
        }
      }
    );
  };

  useEffect(() => {
    getDocuments();

    return () => {
      isMounted.current = false;
    }
  }, [
    getDocuments
  ])

  // When viewing a document, set the current VGM values or temptale number
  useEffect(() => {
    if (viewingDocument && (props.userType === 'packHouse' || props.userType === 'plugDepot' || props.userType === 'admin')) {
      if (isVGMDocument(viewingDocument.documentName.split('.')[0])) {
        setVgmLoadpoint1(props.load.vgmLoadpoint1 || '');
        setVgmLoadpoint2(props.load.vgmLoadpoint2 || '');
        setContainerTare(props.load.containerTare || '');
        // Clear any existing errors when loading data
        setVgmLoadpoint1Error('');
        setVgmLoadpoint2Error('');
        setContainerTareError('');
        setTotalVgmError('');
      } else if (isTemptaleDocument(viewingDocument.documentName.split('.')[0])) {
        setTemptaleNumber(props.load.temptaleNumber || '');
      }
    }
  }, [viewingDocument, props.load, props.userType]);

  // Calculate total VGM whenever input values change
  useEffect(() => {
    const vgm1 = parseFloat(vgmLoadpoint1) || 0;
    const vgm2 = parseFloat(vgmLoadpoint2) || 0;
    const tare = parseFloat(containerTare) || 0;
    const total = vgm1 + vgm2 + tare;
    setTotalVgm(total);

    // Validate total VGM
    if (total > 34000) {
      setTotalVgmError('Total VGM cannot exceed 34 tons');
    } else {
      setTotalVgmError('');
    }
  }, [vgmLoadpoint1, vgmLoadpoint2, containerTare]);

  return (
    <>
      <input
        type="file"
        style={{ display: 'none' }}
        onChange={(event) => {
          const file = event.target.files?.[0];
          if (file != null) {
            onClickedFileUpload(file);
          }
        }}
        ref={fileInputRef}
      />

      <div className={classes['documents']}>
        {isLoading ? (
          <div style={{ width: '100%', padding: '2rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Loader size='large' />
          </div>
        ) : (
          <div>
            {props.userType !== 'packHouse' && (
              <>
                <div className={[classes.doc, 'py-1'].join(' ')} key={'01'}>
                  <div style={{ paddingRight: '1rem' }}>CTO</div>

                  <div className={[classes.dropdown, classes.upload].join(' ')}>
                    {isSendLoading ? (
                      <div className='px-2' style={{ display: 'inline-block' }}>
                        <Loader size='tiny' />
                      </div>
                    ) : (
                      props.userType === 'admin' ? (
                        <FaWhatsapp style={{ color: 'var(--theme-blue)', marginRight: '0.5rem' }} onClick={() => setIsSendingCTO(true)} />
                      ) : null
                    )}

                    <FaEye style={{ color: 'var(--theme-blue)', marginRight: '0.5rem' }} onClick={() => setShowPdf('cto')} />
                    <PDFDownloadLink document={<MyDocument load={props.load} />} fileName={`CTO.${props.load.clientRef}.pdf`}>
                      {({ blob, url, loading, error }) => (loading ? '' : <FaDownload style={{ color: 'var(--theme-blue)' }} />)}
                    </PDFDownloadLink>
                  </div>
                </div>

                {props.userType !== 'exporter' && props.userType !== 'owner' && (
                  <div className={[classes.doc, 'py-1'].join(' ')} key={'02'}>
                    <div style={{ paddingRight: '1rem' }}>Additional Charges</div>

                    <div className={[classes.dropdown, classes.upload].join(' ')}>
                      <FaEye style={{ color: 'var(--theme-blue)', marginRight: '0.5rem' }} onClick={() => setShowPdf('charges')} />
                      <PDFDownloadLink document={<ChargesDocument load={props.load} />} fileName={`Charges.${props.load.clientRef}.pdf`}>
                        {({ blob, url, loading, error }) => (loading ? '' : <FaDownload style={{ color: 'var(--theme-blue)' }} />)}
                      </PDFDownloadLink>
                    </div>
                  </div>
                )}
              </>
            )}

            {renderDocuments()}

            {(props.userType === 'admin' || props.userType === 'packHouse' || props.userType === 'plugDepot' || props.userType === 'exporter') && (
              <div className={classes.extraDocumentsSection} style={{ marginTop: '20px', borderTop: '1px solid #ddd', paddingTop: '15px' }}>
                <h6>Upload Additional Documents</h6>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                  <Input
                    type="text"
                    placeholder="Document name (optional)"
                    value={extraDocumentName}
                    onChange={(e) => setExtraDocumentName(e.target.value)}
                    style={{ marginRight: '10px', flexGrow: 1 }}
                  />
                </div>
                <DragAndDropUpload onFileUpload={onExtraFileUpload}>
                  <div style={{ border: '1px dashed #ccc', padding: '15px', textAlign: 'center', borderRadius: '4px' }}>
                    {isUploadingExtra ?
                      <Loader size='tiny' /> :
                      <>
                        <FaUpload style={{ marginRight: '8px' }} />
                        <span>Drag and drop or click to upload additional documents</span>
                      </>
                    }
                  </div>
                </DragAndDropUpload>
              </div>
            )}
          </div>
        )}
        {props.onClose && (
          <div className={classes.photoButtons} style={{ marginTop: '15px' }}>
            <Button
              style={{ backgroundColor: 'var(--theme-green)', color: 'white', border: 'none' }}
              onClick={props.onClose}
            >
              Close
            </Button>
          </div>
        )}
      </div>

      <Alert
        confirm={(confirmation) => {
          if (confirmation && deletionId != null) {
            deleteDocument(deletionId);
          }
          setDeletionId(null);
        }}
        message="Are you sure you want to delete this document?"
        isOpen={deletionId !== null}
        isConfirm
      />

      {showPdf === 'cto' ? (
        <Modal close={() => setShowPdf(null)} style={{ width: '100%', height: 'calc(100vh - 25px)' }}>
          <LoadPdf load={props.load} close={() => setShowPdf(null)} />
        </Modal>
      ) : null}

      {showPdf === 'charges' ? (
        <Modal close={() => setShowPdf(null)} style={{ width: '100%', height: 'calc(100vh - 25px)' }}>
          <ChargesPdf load={props.load} close={() => setShowPdf(null)} />
        </Modal>
      ) : null}

      {isSendingCTO ? (
        <Alert
          confirm={(confirmation) => {
            if (confirmation) {
              sendCTOToDriver()
            }
            setIsSendingCTO(false)
          }}
          message={
            <div>
              Are you sure you want to send this CTO to the driver?
            </div>
          }
          isOpen={isSendingCTO}
          isConfirm
        />
      ) : null}

      {viewingDocument && (
        <Modal close={() => setViewingDocument(null)} style={isPDFDocument(viewingDocument.documentName) ? { width: '100%', height: 'calc(100vh - 25px)' } : undefined}>
          <div>
            {(props.userType === 'packHouse' || props.userType === 'plugDepot' || props.userType === 'admin') && isVGMDocument(viewingDocument.documentName.split('.')[0]) && (
              <div className={classes.vgmDataContainer}>
                <div className="form-group mb-2">
                  <label>VGM Loadpoint 1 (kg)</label>
                  <Input
                    type="number"
                    value={vgmLoadpoint1}
                    onChange={(e) => handleVgmLoadpoint1Change(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === '.' || e.key === ',') {
                        e.preventDefault();
                      }
                    }}
                    className={`form-control form-control-sm ${vgmLoadpoint1Error ? 'is-invalid' : ''}`}
                    placeholder="Enter weight in kg"
                    min="0"
                    step="1"
                    pattern="[0-9]*"
                  />
                  {vgmLoadpoint1Error && <div className="invalid-feedback d-block" style={{ fontSize: '0.875rem', color: '#dc3545' }}>{vgmLoadpoint1Error}</div>}
                </div>
                <div className="form-group mb-2">
                  <label>VGM Loadpoint 2 (kg)</label>
                  <Input
                    type="number"
                    value={vgmLoadpoint2}
                    onChange={(e) => handleVgmLoadpoint2Change(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === '.' || e.key === ',') {
                        e.preventDefault();
                      }
                    }}
                    className={`form-control form-control-sm ${vgmLoadpoint2Error ? 'is-invalid' : ''}`}
                    placeholder="Enter weight in kg"
                    min="0"
                    step="1"
                    pattern="[0-9]*"
                  />
                  {vgmLoadpoint2Error && <div className="invalid-feedback d-block" style={{ fontSize: '0.875rem', color: '#dc3545' }}>{vgmLoadpoint2Error}</div>}
                </div>
                <div className="form-group mb-2">
                  <label>Container Tare (kg)</label>
                  <Input
                    type="number"
                    value={containerTare}
                    onChange={(e) => handleContainerTareChange(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === '.' || e.key === ',') {
                        e.preventDefault();
                      }
                    }}
                    className={`form-control form-control-sm ${containerTareError ? 'is-invalid' : ''}`}
                    placeholder="Enter container tare weight in kg"
                    min="0"
                    step="1"
                    pattern="[0-9]*"
                  />
                  {containerTareError && <div className="invalid-feedback d-block" style={{ fontSize: '0.875rem', color: '#dc3545' }}>{containerTareError}</div>}
                </div>
                <div className="form-group mb-3">
                  <label><strong>Total VGM (kg)</strong></label>
                  <div className={`form-control form-control-sm ${classes.totalVgm} ${totalVgmError ? 'is-invalid' : ''}`} style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold', color: totalVgmError ? '#dc3545' : 'inherit' }}>{totalVgm.toLocaleString()}</div>
                  {totalVgmError && <div className="invalid-feedback d-block" style={{ fontSize: '0.875rem', color: '#dc3545' }}>{totalVgmError}</div>}
                </div>
                <div className="d-flex justify-content-center">
                  <Button
                    style={{ backgroundColor: 'var(--theme-green)', color: 'white', border: 'none' }}
                    onClick={() => {
                      updateVGMData();
                    }}
                    disabled={isVgmUpdating}
                  >
                    {isVgmUpdating ? <span><Loader size="tiny" /></span> : 'Save VGM Data'}
                  </Button>
                </div>
              </div>
            )}

            {(props.userType === 'packHouse' || props.userType === 'plugDepot') && isTemptaleDocument(viewingDocument.documentName.split('.')[0]) && (
              <div className={classes.vgmDataContainer}>
                <div className="form-group mb-3">
                  <label>Temptale Number</label>
                  <Input
                    type="text"
                    value={temptaleNumber}
                    onChange={(e) => setTemptaleNumber(e.target.value)}
                    className="form-control form-control-sm"
                    placeholder="Enter temptale number"
                  />
                </div>
                <div className="d-flex justify-content-center mb-3">
                  <Button
                    style={{ backgroundColor: 'var(--theme-green)', color: 'white', border: 'none' }}
                    onClick={() => {
                      updateTemptaleNumber();
                    }}
                    disabled={isTemptaleUpdating}
                  >
                    {isTemptaleUpdating ? <span><Loader size="tiny" /></span> : 'Save Temptale Number'}
                  </Button>
                </div>
              </div>
            )}

            {viewingDocument.signedUrl && (
              <>
                {isPDFDocument(viewingDocument.documentName) ? (
                  <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 105px)' }}>
                    <iframe
                      src={`${viewingDocument.signedUrl}#toolbar=0&navpanes=0&scrollbar=0`}
                      width="100%"
                      style={{ border: 'none', flex: 1, minHeight: 0 }}
                      title="PDF Document"
                    />
                    <div style={{ display: 'flex', justifyContent: 'space-around', paddingTop: '1rem', flexShrink: 0 }}>
                      <div style={{ userSelect: 'none', cursor: 'pointer' }} onClick={() => setViewingDocument(null)}>
                        Close
                      </div>
                      <div style={{ cursor: 'pointer' }}>
                        <div onClick={() => forceDownload(viewingDocument.signedUrl, viewingDocument.documentName)} style={{ color: 'white', backgroundColor: 'var(--theme-green)', paddingRight: '1rem', paddingLeft: '1rem', borderRadius: '5px', userSelect: 'none', paddingTop: '0.25rem', paddingBottom: '0.25rem', textDecoration: 'none' }}>
                          Download
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className={classes.photoContainer}>
                    <img src={viewingDocument.signedUrl} alt="Load Document" width={'100%'} />
                  </div>
                )}
              </>
            )}

            {!isPDFDocument(viewingDocument.documentName) && (
              <div className={classes.photoButtons}>
                <Button
                  style={{ backgroundColor: 'var(--theme-green)', color: 'white', border: 'none', marginTop: '1rem' }}
                  onClick={() => setViewingDocument(null)}
                >
                  Close
                </Button>
              </div>
            )}
          </div>
        </Modal>
      )}
    </>
  );
};

export default Documents;
